export enum SidebarMode {
    Create = 0,
    Update = 1,
  }